module.exports = __webpack_public_path__ + "img/alo-kasko-nav-logo.2df64fc7.svg";